import { post,get } from "../network/index.js";
// 商家估价设置开启/关闭情况查询接口
const queryOpenStatus = (data) => {
  return get('/merc-eval-price/setting/query', data)
};

// 服务费设置
const setServiceCharge = (data) => {
  return post("/merc-eval-price/setting/service-charge/set", data);
};
// 商家估价功能开启/关闭设置
const setOpenStatus = data => {
  return post('/merc-eval-price/setting/set', data)
}
// --------------估价品类----------------------
//新增
const categoryAdd = data => {
  return post('/eval-price/category/add', data)
}
//列表
const categoryList = data => {
  return get('/eval-price/category/list', data)
}
//删除
const categoryDelete = data => {
  return post('/eval-price/category/delete', data)
}
//排序
const categorySort = data => {
  return post('/eval-price/category/sort', data)
}
//修改
const categoryUpdate = data => {
  return post('/eval-price/category/update', data)
}
// --------------估价品类--------end--------------
//估价品类属性-查询
const categoryPropertiesList = data => {
  return get('/eval-price/category-properties/list', data)
}
//---------------------估价品类属性数据--------------
//新增
const categoryPropertiesAdd = data => {
  return post('/eval-price/category-properties-data/add', data)
}
//删除
const categoryPropertiesDelete = data => {
  return post('/eval-price/category-properties-data/delete', data)
}
//查询
const categoryPropertiesDataList = data => {
  return get(`/eval-price/category-properties-data/list?categoryId=${data.categoryId}&propertyId=${data.propertyId}`)
}
//品牌热门标识改变
const categoryPropertiesFlagChange = data => {
  return post('/eval-price/category-properties-data/popular-flag-change', data)
}
//排序
const categoryPropertiesSort = data => {
  return post('/eval-price/category-properties-data/sort', data)
}
//修改
const categoryPropertiesUpdate = data => {
  return post('/eval-price/category-properties-data/update', data)
}
//---------------------估价品类属性数据----end----------

//---------------------估价卡----------
//估价卡变动记录查询接口
const categoryCardList = data => {
  return post('/eval-price-card/change-record-page', data)
}
//估价卡新人赠送设置接口
const categoryCardSet = data => {
  return post('/eval-price-card/do-register-setting', data)
}
//估价卡-手动赠送
const categoryCardPresent = data => {
  return post('/eval-price-card/present', data)
}
//估价卡新人赠送设置查询接口
const categoryCardPresentList = data => {
  return get('/eval-price-card/register-settings-query', data)
}
//---------------------估价卡----------

export default {
  queryOpenStatus,
  setServiceCharge,
  setOpenStatus,
  categoryAdd,
  categoryList,
  categoryDelete,
  categorySort,
  categoryUpdate,
  categoryPropertiesList,
  categoryPropertiesAdd,
  categoryPropertiesDelete,
  categoryPropertiesDataList,
  categoryPropertiesFlagChange,
  categoryPropertiesSort,
  categoryPropertiesUpdate,
  categoryCardList,
  categoryCardSet,
  categoryCardPresent,
  categoryCardPresentList
}
